<mat-sidenav-container (backdropClick)="hideActive()" autosize>
  <mat-sidenav
    class="navigation-container"
    [opened]="(_navWidget$$ | async) ? opened : false"
    [mode]="_sidenavMode$ | async"
    [fixedInViewport]="isHandheld$ | async"
    (keydown.escape)="setNavOpen(false)"
    disableClose
  >
    @if (_navWidget$$ | async; as navWidget) {
      <ng-container
        [dynamicWidget]="navWidget"
        [context]="_navTemplate$$ | async"
      />
    }
  </mat-sidenav>
  <mat-sidenav
    class="side-content-container"
    position="end"
    [style.marginTop.px]="
      (isHandheld$ | async) || (_sideContentMode$ | async) === 'over'
        ? 0
        : (_toolbarHeight$ | async)
    "
    [fixedInViewport]="isHandheld$ | async"
    [opened]="_sideContentOpen$ | async"
    [mode]="_sideContentMode$ | async"
    (keydown.escape)="setSideContentOpen(false)"
    disableClose
  >
    @if (_sideContentWidget$$ | async; as sideContentWidget) {
      <ng-container
        [dynamicWidget]="sideContentWidget"
        [context]="_sideContentContext$$ | async"
      />
    }
  </mat-sidenav>
  <mat-sidenav-content>
    @if (_toolbarWidget$$ | async; as toolbarWidget) {
      <ng-container
        [dynamicWidget]="toolbarWidget"
        [context]="_toolbarTemplate$$ | async"
      />
    }
    <div
      class="page-content-viewport"
      [style.marginTop.px]="_toolbarHeight$ | async"
      [style.paddingLeft]="paddingLeft"
      [style.paddingRight]="paddingRight"
      [style.paddingTop]="paddingTop"
      [style.paddingBottom]="paddingBottom"
    >
      <div
        class="page-content-wrapper"
        [class.centered]="input?.mainContentCentered | parse: context | async"
      >
        @if (_mainContentWidget$$ | async; as mainContentWidget) {
          <ng-container
            [dynamicWidget]="mainContentWidget"
            [context]="_mainContentTemplate$$ | async"
          ></ng-container>
        }
      </div>
    </div>
  </mat-sidenav-content>
</mat-sidenav-container>
